import FastMarquee from "react-fast-marquee";

const ITEMS = [
  "Speed Boats",
  "Power Boats",
  "Yachts",
  "Hull Restoration",
  "Deck & Interior",
  "Waxing & Polishing",
  "Salt Lake City",
  "Showroom Finish",
];

export default function Marquee() {
  return (
    <section className="border-y border-white/10 bg-black py-8 md:py-10" data-testid="marquee-section">
      <FastMarquee speed={40} gradient={false} pauseOnHover>
        {ITEMS.concat(ITEMS).map((item, i) => (
          <span key={i} className="mx-10 md:mx-16 inline-flex items-center gap-10 md:gap-16">
            <span className="font-serif italic text-4xl md:text-6xl text-white/80">{item}</span>
            <span className="text-gold text-2xl md:text-4xl">&#9875;</span>
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
